import { styled as muiStyled } from '@mui/material'

export const DayJsDateSelectorCalendarStyleContainer = muiStyled('div')(
  ({ theme }) => `
    .react-calendar {
        border: none;
        font-family: 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        line-height: 1.2em;
        width: 19em;
        transition: background 200ms linear;
        border-radius: 8px;
        padding: 8px;
    }
    
    /* Navigation buttons */
    .react-calendar__navigation {
        display: flex;
        height: 44px;
        margin-bottom: 1em;
    }
    
    .react-calendar__navigation button {
        min-width: 44px;
        background: none;
        font-size: 16px;
        margin-top: 8px;
        color: rgba(67, 56, 202, 0.85);
        font-weight: 600;
        transition: all 0.2s ease;
    }
    
    .react-calendar__navigation button:enabled:hover,
    .react-calendar__navigation button:enabled:focus {
        background-color: rgba(67, 56, 202, 0.1);
        border-radius: 6px;
        color: rgba(67, 56, 202, 1);
    }
    
    /* Weekday labels */
    .react-calendar__month-view__weekdays {
        text-align: center;
        text-transform: uppercase;
        font-weight: 600;
        font-size: 0.75em;
        color: rgba(67, 56, 202, 0.7);
        margin-bottom: 8px;
    }
    
    .react-calendar__month-view__weekdays__weekday {
        padding: 0.5em;
    }
    
    /* Date tiles */
    .react-calendar__tile {
        max-width: 100%;
        padding: 10px 6.6667px;
        background: none;
        text-align: center;
        line-height: 16px;
        font-size: 0.833em;
        border-radius: 6px;
        transition: all 0.2s ease;
        color: rgba(67, 56, 202, 0.85);
        font-weight: 500;
    }
    
    .react-calendar__tile:enabled:hover,
    .react-calendar__tile:enabled:focus {
        background-color: rgba(67, 56, 202, 0.1);
        transform: scale(1.05);
    }
    
    /* Past dates - lighter shade */
    .react-calendar__tile--past {
        color: #9ca3af;
        opacity: 0.6;
    }
    
    .react-calendar__tile--past:hover {
        opacity: 0.8;
    }
    
    /* Today - clearly visible */
    .react-calendar__tile--today {
        background: linear-gradient(135deg, rgba(67, 56, 202, 0.15) 0%, rgba(99, 102, 241, 0.15) 100%);
        color: #4338ca;
        font-weight: 700;
        border: 2px solid rgba(67, 56, 202, 0.3);
        box-shadow: 0 2px 4px rgba(67, 56, 202, 0.1);
    }
    
    .react-calendar__tile--today:hover {
        background: linear-gradient(135deg, rgba(67, 56, 202, 0.2) 0%, rgba(99, 102, 241, 0.2) 100%);
        border-color: rgba(67, 56, 202, 0.5);
        box-shadow: 0 4px 8px rgba(67, 56, 202, 0.15);
    }
    
    /* Selected date - clearly visible */
    .react-calendar__tile--selected {
        background: linear-gradient(135deg, #4338ca 0%, #6366f1 100%);
        color: #ffffff;
        font-weight: 700;
        border: 2px solid #4338ca;
        box-shadow: 0 2px 8px rgba(67, 56, 202, 0.3);
    }
    
    .react-calendar__tile--selected:hover {
        background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
        box-shadow: 0 4px 12px rgba(67, 56, 202, 0.4);
        transform: scale(1.05);
    }
    
    /* Off days (Saturdays/Sundays or clinic off days) - red color */
    .react-calendar__tile--off-day {
        color: #dc2626;
        font-weight: 600;
        background: rgba(220, 38, 38, 0.08);
    }
    
    .react-calendar__tile--off-day:hover {
        background: rgba(220, 38, 38, 0.15);
        color: #b91c1c;
    }
    
    /* Off day that is also today */
    .react-calendar__tile--off-day.react-calendar__tile--today {
        background: linear-gradient(135deg, rgba(220, 38, 38, 0.2) 0%, rgba(239, 68, 68, 0.2) 100%);
        border-color: rgba(220, 38, 38, 0.4);
        color: #dc2626;
    }
    
    /* Off day that is also selected */
    .react-calendar__tile--off-day.react-calendar__tile--selected {
        background: linear-gradient(135deg, #dc2626 0%, #ef4444 100%);
        border-color: #dc2626;
        color: #ffffff;
    }
    
    /* Past off days */
    .react-calendar__tile--off-day.react-calendar__tile--past {
        color: #f87171;
        opacity: 0.5;
    }
    
    /* Active state (when clicking) */
    .react-calendar__tile--active {
        background: ${theme.palette?.emrPrimary?.default || '#4338ca'};
        color: #ffffff;
        font-weight: 700;
    }
    
    .react-calendar__tile--active:hover {
        background: ${theme.palette?.emrPrimary?.light || '#6366f1'};
    }
    
    /* Disabled dates */
    .react-calendar__tile:disabled {
        background-color: #f3f4f6;
        color: #d1d5db;
        cursor: not-allowed;
    }
    
    /* Neighboring month dates */
    .react-calendar__tile--neighboringMonth {
        color: #d1d5db;
        opacity: 0.5;
    }
`,
)

